import React from 'react'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { ContactInstrumentsListProps, ContactInstrumentsListV1 } from './ContactInstrumentsListV1'
import { ContactInstrumentsListV2 } from './ContactInstrumentsListV2'

export const ContactInstrumentsList = (props: ContactInstrumentsListProps) => {
  const { enableCryptoFiatSend } = useFeatureFlags()

  if (enableCryptoFiatSend) return <ContactInstrumentsListV2 {...props} />

  return <ContactInstrumentsListV1 {...props} />
}
